export default __webpack_public_path__ + "static/media/DSC04787(1).ddc8b58b.jpg";